import { render, staticRenderFns } from "./MortgageFormFrame.vue?vue&type=template&id=8a920990&scoped=true&"
import script from "./MortgageFormFrame.vue?vue&type=script&lang=js&"
export * from "./MortgageFormFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a920990",
  null
  
)

export default component.exports